/**
 * **One session laid over the screen the trainer is on**, and focus back on the control that opened
 * it once it closes (owner, 25 September 2026: „Zobacz sesję" opens the panel in place on `/zadania`
 * and the Pulpit, as it does on the client's Przegląd, rather than leaving for the client's card).
 *
 * Screen state, not the URL's: these two screens carry no session in their address, and a panel
 * opened over a queue is a glance the trainer closes, not a place to link to. The client detail keeps
 * its `?exec=`, which it has had since the first deep link was written.
 *
 * The screen marks what is behind the panel `inert` while `open` is set — the same modality the
 * client detail gives its overlay — and the opener stamps `data-session-opener` with the READ key.
 */

import { useState } from 'react';

import { sessionOpenerKey } from './sessionOpener';
import { useSessionOpenerReturn } from './useSessionOpenerReturn';

export interface InPlaceSession {
  /** The session on screen, or `null`. */
  readonly open: number | null;
  readonly show: (workoutExecutionId: number) => void;
  readonly close: () => void;
}

export function useInPlaceSession(): InPlaceSession {
  const [open, setOpen] = useState<number | null>(null);
  useSessionOpenerReturn(open === null ? null : sessionOpenerKey(open, 'read'));
  return {
    open,
    show: setOpen,
    close: () => {
      setOpen(null);
    },
  };
}
